var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.BarChartGenerator,{attrs:{"chart-data":_setup.chartData,"chart-options":_setup.computedChartOptions}})
}
var staticRenderFns = []

export { render, staticRenderFns }